import React from 'react';
import { IClassName } from '../../../constants';

const AddAppPLogo: React.FC<IClassName> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
      <path d="M18.3583 7.09984V3.3165C18.3583 2.1415 17.825 1.6665 16.5 1.6665H3.52508C2.20008 1.6665 1.66675 2.1415 1.66675 3.3165V7.0915C1.66675 8.27484 2.20008 8.7415 3.52508 8.7415H16.5C17.825 8.74984 18.3583 8.27484 18.3583 7.09984Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.75008 16.475V13.1083C8.75008 11.7833 8.21675 11.25 6.89175 11.25H3.52508C2.20008 11.25 1.66675 11.7833 1.66675 13.1083V16.475C1.66675 17.8 2.20008 18.3333 3.52508 18.3333H6.89175C8.21675 18.3333 8.75008 17.8 8.75008 16.475Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.5 12.9165H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M12.5 16.25H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  );
};

export default AddAppPLogo;
